module.exports = __webpack_public_path__ + "static/media/searching_melody.be3e8d2a.png";